import React from 'react';
import s from './Support.css';
import withStyles from "isomorphic-style-loader/withStyles";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Plan from "../../components/Plan/Plan";
import Badge from "../../components/Common/Badge/Badge";
import Feature from "../../components/Feature/Feature";
import Card from "../../components/Card/Card";
import Button from "@material-ui/core/Button";
import Email from "../../components/Email/Email";

class Support extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    render() {
        return (
            <Container maxWidth="md" style={{ textAlign: 'center' }}>

                <Grid container>
                    <Grid item xs={12} md={2}/>

                    <Grid item xs={12} md={4}>
                        <Card className={s.card}>
                            <h2>Email us</h2>

                            <h5>
                                Payment issues, premium support, partnership, etc.
                            </h5>

                            <Email/>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Card className={s.card}>
                            <h2>Suggest feature, bug</h2>

                            <h5>
                                Something is missing? Tell us about it
                            </h5>

                            <Button className={s.button} href={'http://mavo-dash.idea.informer.com/proj/'} color={'primary'} variant={'contained'} target={'_blank'}>Idea hub</Button>
                        </Card>
                    </Grid>
                </Grid>

                <div className={s.space}/>
            </Container>
        );
    }
}

export default withStyles(s)(Support);